import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { IngredientCompCreateSelectIngPage } from "../ingredient-comp-create-select-ing/ingredient-comp-create-select-ing";
import { IngredientsServices } from "../../services";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Globals } from "../../../../globals";
import { StaticsServices } from '../../../services/statics';
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsServices } from '../../../services/analyticsServices';

/**
 * Generated class for the IngredientCompCreateInfoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-ingredient-comp-create-info',
  templateUrl: 'ingredient-comp-create-info.html',
})
export class IngredientCompCreateInfoPage {


  public form: FormGroup;
  ingredient_name: any;
  ingredient_uid: string;
  update_state: boolean = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public ingredientServices: IngredientsServices,
    public fb: FormBuilder,
    public globals: Globals,
    private toastCtrl: ToastController,
    public staticsServices: StaticsServices,
    public translate: TranslateService,
    public analyticsServices: AnalyticsServices) {
    //Params
    this.update_state = this.navParams.get('update_state');
    this.ingredient_name = this.navParams.get('ingredient_name');

    //Si hacemos update adamptamos la informacion
    if (this.update_state) {
      this.ingredientServices.ingredient_tags = this.navParams.get('tags');
      this.ingredient_uid = this.navParams.get('ingredient_uid');

      var stock_max = 0;
      if (this.navParams.get('stock_max')) {
        stock_max = this.navParams.get('stock_max')
      }

      this.form = fb.group({
        name: [this.navParams.get('ingredient_name'), Validators.compose([Validators.required])],
        measurement: [this.navParams.get('measurement')],
        stock: [this.navParams.get('stock')],
        stock_alert: [this.navParams.get('stock_alert')],
        stock_max: [stock_max],
        sub_recipe: [true],
      });
    } else {
      this.ingredientServices.ingredient_tags = Array();


      this.form = fb.group({
        name: ['', Validators.compose([Validators.required])],
        measurement: ['kg'],
        stock: [0],
        stock_alert: [0],
        stock_max: [0],
        sub_recipe: [true],
      });
    }

  }

  submit() {
    if (this.form.valid) {
      if (!this.update_state) {
        this.insert();
      } else {
        this.update();
      }
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-introduce-nombre-ingrediente-compuesto-continuar'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

  insert() {
    this.ingredientServices.afs.collection('ingredients').add({
      'UID_RESTAURANT': this.globals.restaurant_uid,
      'name': this.form.value.name,
      'measurement': 'kg',
      'stock': 0,
      'stock_alert': 0,
      'stock_max': 0,
      'sub_recipe': true,
      'tags': this.ingredientServices.ingredient_tags,
      'tags_static': this.ingredientServices.ingredient_tags.toString(),
      'price_static': 0,
      'provider_static': this.translate.instant('general-sin-proveedor'),
      'foodcost': Array(),
      'created_at': new Date(),
      'updated_at': new Date(),

    }).then(doc => {
      this.globals.GAtrackView('Ingredients', 'Ingredients - Name - Create', this.globals.restaurant.email, 'Create/Update', 'Create ingredient name', 'Ingredients', this.form.value.name);
      this.analyticsServices.trackingExpStock('create_ingredient', this.globals.tracking_exp['create_ingredient'], doc.id);
      //Get the UID Document
      this.sendData()
      this.ingredientServices.ingredient_tags = null;
      this.navCtrl.push(IngredientCompCreateSelectIngPage, {
        update: false,
        ingredient_uid: doc.id,
        ingredient_name: this.form.value.name,
        ingredient_measurement: this.form.value.measurement
      });
    });
  }

  update() {
    this.ingredientServices.afs.collection('ingredients').doc(this.ingredient_uid).update({
      'name': this.form.value.name,
      'measurement': this.form.value.measurement,
      'stock': this.form.value.stock,
      'stock_alert': this.form.value.stock_alert,
      'stock_max': this.form.value.stock_max,
      'tags': this.ingredientServices.ingredient_tags,
      'tags_static': this.ingredientServices.ingredient_tags.toString(),
      'sub_recipe': true,
      'updated_user': this.globals.user_name,
      'updated_at': new Date(),
    }).then(() => {
      this.globals.GAtrackView('Ingredients', 'Ingredients - Name - Update', this.globals.restaurant.email, 'Create/Update', 'Update name', 'Ingredients', this.form.value.name);
      this.sendData();
      this.ingredientServices.ingredient_tags = null;
      this.staticsServices.changeStateStaticWait(true);
      this.navCtrl.pop();
    });
  }

  sendData() {
    for (let value of this.ingredientServices.ingredient_tags) {
      this.globals.dataSet('ingredient_tag', value, '', this.form.value.name);
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/ingredients/ingredient-comp-create/ingredient-comp-create-info/ingredient-comp-create-info.ts